import useAdBlockStore from "store/AdBlockStore";
import {
  IncentiveAirMilesTextBuilder,
  IncentiveCouponTextBuilder,
  IncentiveDownloadTextBuilder,
  IncentiveEntirePurchaseSavingsTextBuilder,
  IncentiveNextShoppingTripTextBuilder,
  IncentiveRewardsTextBuilder,
  IncentiveAdditionalCouponTextBuilder,
  IncentiveCreditCard1TextBuilder,
  IncentiveCreditCard2TextBuilder,
  IncentiveFreeItemTextBuilder,
  IncentiveWebPromotionsTextBuilder,
  IncentiveStoreSavingsTextBuilder,
  IncentiveGasTextBuilder,
  IncentiveTradeInSavingsTextBuilder,
  IncentiveExtraSavingsTextBuilder,
  IncentivePharmacyServiceTextBuilder
} from "../../index";

export const IncentiveTextBuilder = () => {
  const currentIncentive = useAdBlockStore((state) => state.currentOffer);
  const updateCurrentIncentive = useAdBlockStore((state) => state.updateCurrentIncentive);
  const type = currentIncentive?.incentive_type || '';
  const value = currentIncentive?.incentive_text || '';

  const onChange = (e) => {
    console.log('onChnage', e);
    updateCurrentIncentive({ incentive_text: e })
  };

  return (
    <>
      <h6 className="p-1" style={{ color: '#66c0e1' }}>Incentive Text Builder</h6>

      {type === "Air Miles" && (
        <IncentiveAirMilesTextBuilder
          value={type === "Air Miles" ? value : "Earn 2000 air miles"}
          onChange={onChange}
        />
      )}
      {type === "Clearance" && <></>}

      {type === "Coupon" && (
        <IncentiveCouponTextBuilder
          value={type === "Coupon" ? value : "Save 10%"}
          onChange={onChange}
        />
      )}

      {type === "Download" && (
        <IncentiveDownloadTextBuilder
          value={type === "Download" ? value : "$5 & Up"}
          onChange={onChange}
        />
      )}
      {type === "Entire Purchase Savings" && (
        <IncentiveEntirePurchaseSavingsTextBuilder
          value={type === "Entire Purchase Savings" ? value : "2/$2"}
          onChange={onChange}
        />
      )}
      {type === "Extra Coupons" && <></>}
      {type === "Extra Savings" && (
        <IncentiveExtraSavingsTextBuilder
          value={
            type === "Extra Savings" ? value : "save $10.00 on item w/purchase"
          }
          onChange={onChange}
        />
      )}
      {type === "Free Shipping" && <></>}
      {type === "Next Shopping Trip" && (
        <IncentiveNextShoppingTripTextBuilder
          value={
            type === "Next Shopping Trip"
              ? value
              : "save $7.00 on next shopping visit"
          }
          onChange={onChange}
        />
      )}
      {type === "Pharmacy Service" && (
        <IncentivePharmacyServiceTextBuilder
          value={type === "Pharmacy Service" ? value : "A1C Screenings"}
          onChange={onChange}
        />
      )}
      {type === "RewardsI" && (
        <IncentiveRewardsTextBuilder
          value={type === "RewardsI" ? value : "w/purchase/$10.00"}
          onChange={onChange}
        />
      )}
      {type === "Rollback" && <></>}
      {type === "Saturdate" && <></>}
      {type === "Snap/EBT" && <></>}
      {type === "Sweepstakes" && <></>}
      {type === "Additional Coupon" && (
        <IncentiveAdditionalCouponTextBuilder
          value={
            type === "Additional Coupons"
              ? value
              : "$2.00 Coupon Available Through Sunday Paper"
          }
          onChange={onChange}
        />
      )}
      {type === "Credit CardI" && (
        <IncentiveCreditCard1TextBuilder
          value={
            type === "Credit CardI"
              ? value
              : "No Interest for 12 months w/store credit card"
          }
          onChange={onChange}
        />
      )}
      {(type === "Credit CardII" || type === "CreditCardII") && (
        <IncentiveCreditCard2TextBuilder
          value={
            (type === "Credit CardII" || type === "CreditCardII") ? value : "save $10.00 w/store credit card"
          }
          onChange={onChange}
        />
      )}
      {type === "Earn Free Item" && <></>}
      {type === "Free Item" && (
        <IncentiveFreeItemTextBuilder
          value={type === "Free Item" ? value : "Free 2 Items"}
          onChange={onChange}
        />
      )}
      {type === "Web Promotions" && (
        <IncentiveWebPromotionsTextBuilder
          value="Web Promotions"
          onChange={onChange}
        />
      )}
      {type === "Store Savings" && (
        <IncentiveStoreSavingsTextBuilder
          value={value ? value : "Earn"}
          onChange={onChange}
        />
      )}
      {type === "Gas" && (
        <IncentiveGasTextBuilder
          value={type === "Gas" ? value : "Earn $0.05 per gallon"}
          onChange={onChange}
        />
      )}
      {type === "Trade-in savings" && (
        <IncentiveTradeInSavingsTextBuilder
          value={
            type === "Trade-in savings"
              ? value
              : "$10.00 or more trade in savings"
          }
          onChange={onChange}
        />
      )}
    </>
  );
};
